import {useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';

import DocumentListSearch from '../../DocumentListSearch';
import DossierStateResume from '../../dossier/DossierStateResume';

import {useClientDetailsStore} from '../ClientDetailsStore';

function DocumentsList() {
  const organisation = useSelector(globalState => globalState.organisation);
  const {
    dispatch,
    state: {documents, dossierState}
  } = useClientDetailsStore();

  function handleFilterDocuments(filteredDocuments) {
    const totalCount = filteredDocuments.length;
    dispatch({type: 'FILTER_DOCUMENTS', totalCount});
  }

  function handleRefreshDocuments() {
    dispatch({type: 'FETCH_DOCUMENTS'});
  }

  return <>
    {dossierState.error ? <span><Translate value="error.generic"/></span> :
      <DossierStateResume
        loading={dossierState.loading}
        dossierCountry={organisation.country}
        dossierState={dossierState}
      />
    }
    {documents.error ? <span><Translate value="error.generic"/></span> :
      <DocumentListSearch
        organisationId={organisation.organisationId}
        documents={documents.list}
        dossierCountry={organisation.country}
        onRefreshDocuments={handleRefreshDocuments}
        depositor={organisation.depositor}
        loading={documents.loading}
        onFilterDocuments={handleFilterDocuments}
      />
    }
  </>;
}

export default DocumentsList;
